module.exports = __webpack_public_path__ + "static/media/sortAsc.966c3acd.svg";